import { render } from "./NavigationItemWrapper.vue?vue&type=template&id=3eede182"
import script from "./NavigationItemWrapper.vue?vue&type=script&lang=ts"
export * from "./NavigationItemWrapper.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem});
